import { useNavigate } from "react-router-dom";
import { Reveal, Eyebrow } from "../lib/ui";
import { ArrowRight } from "lucide-react";

const STEPS = [
  {
    num: "01",
    title: "Fortæl os om sagen",
    text: "Du udfylder en kort formular med de vigtigste oplysninger — det tager få minutter, og du kan vedhæfte relevante dokumenter.",
  },
  {
    num: "02",
    title: "Vi vurderer henvendelsen",
    text: "Vi gennemgår din sag og finder ud af, hvordan vi bedst kan hjælpe dig videre.",
  },
  {
    num: "03",
    title: "Vi kontakter dig",
    text: "Du bliver kontaktet, så vi sammen kan aftale næste skridt. Ingen forpligtelser — bare en klar plan.",
  },
];

export const Process = () => {
  const navigate = useNavigate();

  return (
  <section id="proces" className="scroll-mt-20 py-16 sm:py-24 lg:py-28">
    <div className="mx-auto max-w-[1440px] px-6 sm:px-8 lg:px-12">
      <div className="grid gap-8 lg:grid-cols-12 lg:items-end">
        <Reveal className="lg:col-span-8">
          <Eyebrow>Sådan fungerer det</Eyebrow>
          <h2 className="mt-4 max-w-xl text-4xl font-semibold tracking-[-0.02em] text-slate-900 sm:text-5xl">
            Kom hurtigt i gang med tre enkle trin
          </h2>
        </Reveal>
        <Reveal delay={0.08} className="lg:col-span-4">
          <p className="text-sm leading-relaxed text-slate-500 lg:text-right">
            Ingen forpligtelser — du får en vurdering af din sag, inden du beslutter dig.
          </p>
        </Reveal>
      </div>

      <div className="mt-14 grid gap-10 lg:grid-cols-3 lg:gap-8">
        {STEPS.map((s, i) => (
          <Reveal key={s.num} delay={i * 0.1}>
            <div data-testid={`process-step-${i + 1}`} className="border-t-2 border-slate-900 pt-8">
              <span className="text-6xl font-semibold tracking-tight text-brand-600/25">{s.num}</span>
              <h3 className="mt-4 text-xl font-semibold tracking-tight text-slate-900">{s.title}</h3>
              <p className="mt-3 text-base leading-relaxed text-slate-600">{s.text}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1}>
        <div className="mt-14 flex justify-center">
          <button
            data-testid="process-cta"
            onClick={() => navigate("/kontakt")}
            className="group inline-flex items-center gap-3 rounded-full bg-brand-950 py-3 pl-7 pr-2.5 text-sm font-semibold text-white transition-colors duration-200 hover:bg-brand-900"
          >
            Fortæl os om din sag
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-white text-brand-600 transition-transform duration-200 group-hover:rotate-[-45deg]">
              <ArrowRight className="h-3.5 w-3.5" strokeWidth={2.2} />
            </span>
          </button>
        </div>
      </Reveal>
    </div>
  </section>
  );
};

export default Process;